/** Iniciativas de contato */
export interface ContatoIniciativa {
    id: number;
    nome: string;
    descricao: string;
    iconClass: string;
}

export const CONTATO_INICIATIVA_ATIVA: ContatoIniciativa = {
    id: 1,
    nome: 'Ativa',
    descricao: 'Você tomou a iniciativa de entrar em contato com o cliente',
    iconClass: 'fas fa-expand-alt'
};

export const CONTATO_INICIATIVA_RECEPTIVA: ContatoIniciativa = {
    id: 2,
    nome: 'Receptiva',
    descricao: 'O cliente tomou a iniciativa de entrar em contato contigo',
    iconClass: 'fas fa-compress-alt'
};


export const CONTATOS_INICIATIVAS: ContatoIniciativa[] = [
    CONTATO_INICIATIVA_ATIVA,
    CONTATO_INICIATIVA_RECEPTIVA
];

/** Verifica se a iniciativa do contato é Ativa */
export function isContatoIniciativaAtiva(id: number): boolean {
    return id === CONTATO_INICIATIVA_ATIVA.id;
}

/** Verifica se a iniciativa do contato é Receptiva */
export function isContatoIniciativaRepectivo(id: number): boolean {
    return id === CONTATO_INICIATIVA_RECEPTIVA.id;
}
